'use client'

import { LoaderDS } from '@src/components/blocks/loader-ds'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { type LoaderPropTypes, LoaderLegacy } from './loader-legacy'

export const Loader = (props: LoaderPropTypes) => {
  if (shouldUseDesignSystem()) {
    return <LoaderDS {...props} />
  }
  return <LoaderLegacy {...props} />
}
